import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export const getAllTakhfifHayeJarimehSales = createAsyncThunk(
  'TakhfifJarimehSales/GetAllTakhfifHayeJarimehSales',
  async () => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.TakhfifJarimehSales.GetAllTakhfifHayeJarimehSales}`,
    });
  }
);
